// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#store-image-picker-spinner-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-col {
  padding: 0;
  border: 1px solid lightgray;
}
ion-col ion-checkbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  --background: lightgray;
}
ion-col .checkbox-disabled {
  opacity: 0.5;
  --border-color-checked: var(--ion-color-primary, black);
}
ion-col ion-icon {
  transform: rotate(90deg);
  position: absolute;
  top: 5px;
  left: 5px;
  background: rgba(0, 0, 0, 0.3);
  color: white;
  border-radius: 8px;
  width: 16px;
  height: 16px;
  padding: 2px;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/store-core/lib/components/store-image-picker/store-image-picker.page.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,UAAA;EACA,2BAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AACJ;AACE;EACE,YAAA;EACA,uDAAA;AACJ;AAEE;EACE,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAAJ","sourcesContent":["#store-image-picker-spinner-wrapper {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nion-col {\n  padding: 0;\n  border: 1px solid lightgray;\n\n  ion-checkbox {\n    position: absolute;\n    bottom: 5px;\n    right: 5px;\n    width: 24px;\n    height: 24px;\n    --background: lightgray;\n  }\n  .checkbox-disabled {\n    opacity: 0.5;\n    --border-color-checked: var(--ion-color-primary, black);\n  }\n\n  ion-icon {\n    transform: rotate(90deg);\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    background: rgba(0, 0, 0, 0.3);\n    color: white;\n    border-radius: 8px;\n    width: 16px;\n    height: 16px;\n    padding: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
